export default __webpack_public_path__ + "static/media/tutorial_privileges@3x.9e4f6ec8.png";